/** @format */
import { EChartsOption } from 'echarts'

// tooltip配置：包含位置优化，防止溢出容器
export const echartTooltipOptions: EChartsOption['tooltip'] = {
  trigger: 'axis',
  enterable: true,
  position: (point, params, dom, rect, size) => {
    const [mouseX, mouseY] = point
    const { contentSize, viewSize } = size

    // X轴溢出处理：如果鼠标位置 + tooltip宽度超过视图宽度，则显示在鼠标左侧
    const x = mouseX > viewSize[0] - contentSize[0] ? Math.max(0, mouseX - contentSize[0]) : mouseX

    // Y轴溢出处理
    const y = mouseY > viewSize[1] - contentSize[1] ? Math.max(0, mouseY - contentSize[1]) : mouseY

    return [x, y]
  }
}

// 默认配置
export const echartDefaultOption: EChartsOption = {
  color: ['#3083E4', '#00E5C2', '#25CBFF', '#6F5EFA', '#FF5C62', '#FF9846'],
  grid: {
    left: '10px',
    right: '25px',
    top: '30px',
    bottom: '20px',
    containLabel: true
  }
}
